<ng-container *ngxPermissionsOnly="'market_discovery.company.show-datacollectief-icon'">
  <i class="fas fa-arrow-up-right-from-square" *ngIf="item[field]"></i>
</ng-container>
